var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "sku-bind-table-item-modal",
      attrs: {
        "close-on-click-modal": false,
        visible: _vm.show,
        title: "",
        width: "600px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
        close: _vm.onChange,
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.drawRow.type == "add"
                ? _vm.$t("stores::products-info::add_sku")
                : _vm.drawRow.type == "edit"
                ? _vm.$t("stores::products-info::edit_sku")
                : _vm.$t("stores::products-info::copy_sku")
            ) +
            " "
        ),
      ]),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "user-body",
          attrs: {
            model: _vm.params,
            rules: _vm.rules,
            "label-position": "top",
            "label-width": "100px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "", "label-width": "0", prop: "imageUrl" } },
            [
              _c(
                "div",
                {
                  staticClass: "upload-wrap",
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = true
                    },
                  },
                },
                [
                  _vm.params.imageUrl
                    ? _c("el-image", {
                        staticClass: "avatar",
                        attrs: { src: _vm.params.imageUrl, fit: "contain" },
                      })
                    : _c("span", { staticClass: "up-icon" }, [_vm._v("+")]),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "content-wrapper mt-12" },
            [
              _c("div", { staticClass: "content-title mb-12" }, [
                _vm._v(_vm._s(_vm.$t("stores::products-info::base_info"))),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 8 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "stores::products-info::purchase_price"
                            ),
                            prop: "purchasePrice",
                          },
                        },
                        [
                          _c("el-input-number", {
                            staticClass: "input-item",
                            attrs: {
                              placeholder: _vm.$t(
                                "system::common::input_holder"
                              ),
                              min: 0,
                              "controls-position": "right",
                              size: "small",
                            },
                            model: {
                              value: _vm.params.purchasePrice,
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "purchasePrice", $$v)
                              },
                              expression: "params.purchasePrice",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "stores::products-info::compare_at_price"
                            ),
                            prop: "compareAtPrice",
                          },
                        },
                        [
                          _c("el-input-number", {
                            staticClass: "input-item",
                            attrs: {
                              placeholder: _vm.$t(
                                "system::common::input_holder"
                              ),
                              min: 0,
                              "controls-position": "right",
                              size: "small",
                            },
                            model: {
                              value: _vm.params.compareAtPrice,
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "compareAtPrice", $$v)
                              },
                              expression: "params.compareAtPrice",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("stores::products-info::sale_price"),
                            prop: "salePrice",
                          },
                        },
                        [
                          _c("el-input-number", {
                            staticClass: "input-item",
                            attrs: {
                              placeholder: _vm.$t(
                                "system::common::input_holder"
                              ),
                              min: 0,
                              "controls-position": "right",
                              size: "small",
                            },
                            model: {
                              value: _vm.params.salePrice,
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "salePrice", $$v)
                              },
                              expression: "params.salePrice",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("stores::products-info::safe_stock"),
                            prop: "safeInventory",
                          },
                        },
                        [
                          _c("el-input-number", {
                            staticClass: "input-item",
                            attrs: {
                              placeholder: _vm.$t(
                                "system::common::input_holder"
                              ),
                              min: 0,
                              "controls-position": "right",
                              size: "small",
                            },
                            model: {
                              value: _vm.params.safeInventory,
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "safeInventory", $$v)
                              },
                              expression: "params.safeInventory",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.params && !_vm.params.hasOwnProperty("id")
                    ? _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "stores::products-info::first_stock"
                                ),
                                prop: "skuInventory",
                              },
                            },
                            [
                              _c("el-input-number", {
                                staticClass: "input-item",
                                attrs: {
                                  placeholder: _vm.$t(
                                    "system::common::input_holder"
                                  ),
                                  min: 0,
                                  "controls-position": "right",
                                  size: "small",
                                },
                                model: {
                                  value: _vm.params.skuInventory,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.params, "skuInventory", $$v)
                                  },
                                  expression: "params.skuInventory",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("stores::products-info::weight"),
                            prop: "weight",
                          },
                        },
                        [
                          _c("el-input-number", {
                            staticClass: "input-item",
                            staticStyle: { width: "105px" },
                            attrs: {
                              placeholder: _vm.$t(
                                "system::common::input_holder"
                              ),
                              min: 0,
                              "controls-position": "right",
                              size: "small",
                            },
                            model: {
                              value: _vm.params.weight,
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "weight", $$v)
                              },
                              expression: "params.weight",
                            },
                          }),
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "70px",
                                "margin-left": "6px",
                              },
                              attrs: {
                                "popper-append-to-body": false,
                                size: "small",
                              },
                              model: {
                                value: _vm.params.weightUnit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.params, "weightUnit", $$v)
                                },
                                expression: "params.weightUnit",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "g", value: "g" },
                              }),
                              _c("el-option", {
                                attrs: { label: "kg", value: "kg" },
                              }),
                              _c("el-option", {
                                attrs: { label: "oz", value: "oz" },
                              }),
                              _c("el-option", {
                                attrs: { label: "lb", value: "lb" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("stores::products-info::long"),
                            prop: "length",
                          },
                        },
                        [
                          _c("el-input-number", {
                            staticClass: "input-item",
                            staticStyle: { width: "105px" },
                            attrs: {
                              placeholder: _vm.$t(
                                "system::common::input_holder"
                              ),
                              precision: 2,
                              min: 0,
                              "controls-position": "right",
                              size: "small",
                            },
                            model: {
                              value: _vm.params.length,
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "length", $$v)
                              },
                              expression: "params.length",
                            },
                          }),
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "70px",
                                "margin-left": "6px",
                              },
                              attrs: {
                                "popper-append-to-body": false,
                                size: "small",
                              },
                              model: {
                                value: _vm.params.sizeUnit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.params, "sizeUnit", $$v)
                                },
                                expression: "params.sizeUnit",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "cm", value: "cm" },
                              }),
                              _c("el-option", {
                                attrs: { label: "m", value: "m" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("stores::products-info::width"),
                            prop: "wide",
                          },
                        },
                        [
                          _c("el-input-number", {
                            staticClass: "input-item",
                            staticStyle: { width: "105px" },
                            attrs: {
                              placeholder: _vm.$t(
                                "system::common::input_holder"
                              ),
                              precision: 2,
                              min: 0,
                              "controls-position": "right",
                              size: "small",
                            },
                            model: {
                              value: _vm.params.wide,
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "wide", $$v)
                              },
                              expression: "params.wide",
                            },
                          }),
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "70px",
                                "margin-left": "6px",
                              },
                              attrs: {
                                "popper-append-to-body": false,
                                size: "small",
                              },
                              model: {
                                value: _vm.params.sizeUnit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.params, "sizeUnit", $$v)
                                },
                                expression: "params.sizeUnit",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "cm", value: "cm" },
                              }),
                              _c("el-option", {
                                attrs: { label: "m", value: "m" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("stores::products-info::height"),
                            prop: "high",
                          },
                        },
                        [
                          _c("el-input-number", {
                            staticClass: "input-item",
                            staticStyle: { width: "105px" },
                            attrs: {
                              placeholder: _vm.$t(
                                "system::common::input_holder"
                              ),
                              precision: 2,
                              min: 0,
                              "controls-position": "right",
                              size: "small",
                            },
                            model: {
                              value: _vm.params.high,
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "high", $$v)
                              },
                              expression: "params.high",
                            },
                          }),
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "70px",
                                "margin-left": "6px",
                              },
                              attrs: {
                                "popper-append-to-body": false,
                                size: "small",
                              },
                              model: {
                                value: _vm.params.sizeUnit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.params, "sizeUnit", $$v)
                                },
                                expression: "params.sizeUnit",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "cm", value: "cm" },
                              }),
                              _c("el-option", {
                                attrs: { label: "m", value: "m" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              [
                _c(
                  "div",
                  [
                    _c("div", { staticClass: "content-title mb-12" }, [
                      _vm._v(
                        _vm._s(_vm.$t("stores::products-info::attr_info"))
                      ),
                    ]),
                    _vm.params.options && _vm.params.options.length
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 8 } },
                          _vm._l(_vm.params.options, function (item, index) {
                            return _c(
                              "el-col",
                              { key: index, attrs: { span: 8 } },
                              [
                                item.list && item.list.length
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: item.name,
                                          prop: item.name,
                                          rules: {
                                            required: true,
                                            message:
                                              "" +
                                              _vm.$t(
                                                "system::common::input_holder"
                                              ) +
                                              item.name,
                                            trigger: "blur",
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              placeholder:
                                                "" +
                                                _vm.$t(
                                                  "system::common::input_holder"
                                                ) +
                                                item.name,
                                              "popper-append-to-body": false,
                                              size: "small",
                                            },
                                            model: {
                                              value: _vm.params[item.name],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.params,
                                                  item.name,
                                                  $$v
                                                )
                                              },
                                              expression: "params[item.name]",
                                            },
                                          },
                                          _vm._l(
                                            item.list,
                                            function (option, i) {
                                              return _c("el-option", {
                                                key: i,
                                                attrs: {
                                                  label: option.value,
                                                  value: option.value,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: item.name,
                                          prop: item.name,
                                          rules: {
                                            required: true,
                                            message:
                                              "" +
                                              _vm.$t(
                                                "system::common::input_holder"
                                              ) +
                                              item.name,
                                            trigger: "blur",
                                          },
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder:
                                              "" +
                                              _vm.$t(
                                                "system::common::input_holder"
                                              ) +
                                              item.name,
                                            size: "small",
                                          },
                                          model: {
                                            value: _vm.params[item.name],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.params,
                                                item.name,
                                                $$v
                                              )
                                            },
                                            expression: "params[item.name]",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                              ],
                              1
                            )
                          }),
                          1
                        )
                      : [
                          _c(
                            "el-button",
                            {
                              attrs: { icon: "el-icon-plus", size: "small" },
                              on: { click: _vm.onAddAttr },
                            },
                            [_vm._v("添加属性")]
                          ),
                        ],
                  ],
                  2
                ),
              ],
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.onChange } }, [
            _vm._v(_vm._s(_vm.$t("system::common::btn::cancel"))),
          ]),
          _c(
            "el-button",
            {
              attrs: { loading: _vm.loading, type: "primary" },
              on: { click: _vm.onSave },
            },
            [_vm._v(" " + _vm._s(_vm.$t("system::common::btn::confirm")) + " ")]
          ),
        ],
        1
      ),
      _c("ImgList", {
        attrs: { images: _vm.images },
        on: { select: _vm.selectImg },
        model: {
          value: _vm.dialogVisible,
          callback: function ($$v) {
            _vm.dialogVisible = $$v
          },
          expression: "dialogVisible",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }